import api from "./api";
const endpoint = "FileUploadController";
export const uploadService = {
  async uploadFile(file_data) {
    try {
      const formData = new FormData();
      formData.append("file", file_data);
      const result = await api.post(endpoint + "/uploadFile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
